<template>
  <img class="ishikawa-diagram" :src="diagramSrc" :alt="name" />
</template>

<script setup lang="ts">
import { renderIshikawaSvg, svgDataUri } from "@fi-solutions/lisa-shared";
import { computed } from "vue";
import { useTranslation } from "@/language/translation";
import type { ReasonType } from "./SQDCIshikawaDraft";
import {
  createDefaultIshikawaConfig,
  localizedIshikawaAreas,
  type IshikawaAreaConfig,
} from "./ishikawaConfig";

type DiagramReason = {
  name: string;
  type: ReasonType;
  selected: boolean;
};

const props = defineProps<{
  name: string;
  reasons: DiagramReason[];
  areas?: IshikawaAreaConfig[];
}>();

const { t, locale } = useTranslation();
const diagramSrc = computed(() =>
  svgDataUri(
    renderIshikawaSvg(
      {
        name: props.name,
        reasons: props.reasons,
        areas: localizedIshikawaAreas(
          props.areas ?? createDefaultIshikawaConfig(t).areas,
          locale.value,
        ),
      },
      {
        moreCauses: (count) =>
          t("modules.sqdc.components.eventActionBoard.modals.SQDCIshikawaField.moreCauses", {
            count,
          }),
      },
    ),
  ),
);
</script>

<style lang="scss" scoped>
.ishikawa-diagram {
  display: block;
  width: 100%;
  height: auto;
  min-height: 14rem;
  object-fit: contain;
}
</style>
